module.exports = __webpack_public_path__ + "img/rpa1_mb.f3090d85.jpg";